export {default as TextDocumentViewer} from './text-document-viewer-redux';
